import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Chip,
  Typography,
} from '@mui/material';
import CertificateLink from '../CertificateLink';
import OrderItemClientNote from '../OrderItemClientNote';
import { DIAMOND_TYPES } from '../../constants/appConstants';
import { formatDateTime } from '../../utils/dateFormat';
import {
  getCertifiedCertificateNumberOrNull,
  getCertifiedDiamondSpecsWithWeight,
  getEffectiveItemDisplayType,
  getItemDetails,
  getItemLab,
  getItemPricePerCt,
  getItemRef,
  getItemStatusColorClientDetail,
  getItemStatusLabel,
  getItemTypeLabel,
} from '../../utils/orderItemDisplay';

/**
 * Client portal order-item card (My Account Items tab and check detail item list).
 */
function ClientOrderItemCard({ item, t, displayPrice }) {
  const displayType = getEffectiveItemDisplayType(item);
  const certNumber = getCertifiedCertificateNumberOrNull(item);
  const specsWithWeight = getCertifiedDiamondSpecsWithWeight(item);

  return (
    <Card variant="outlined">
      <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap" mb={0.5}>
          <Chip label={getItemTypeLabel(item, t)} size="small" variant="outlined" />
          <Chip
            label={getItemStatusLabel(item.status, t)}
            color={getItemStatusColorClientDetail(item.status)}
            size="small"
          />
          <Typography variant="caption" color="text.secondary" sx={{ ml: 'auto' }}>
            {item.createdAt ? formatDateTime(item.createdAt) : '—'}
          </Typography>
        </Box>
        {displayType === DIAMOND_TYPES.CERTIFIED && certNumber ? (
          <CertificateLink
            certificateNumber={certNumber}
            lab={getItemLab(item)}
            variant="body2"
            sx={{ fontWeight: 'bold' }}
          />
        ) : (
          <Typography variant="body2" fontWeight="bold">{getItemRef(item)}</Typography>
        )}
        {displayType === DIAMOND_TYPES.CERTIFIED && certNumber && specsWithWeight !== '—' && (
          <Typography variant="caption" color="text.secondary" display="block">
            {specsWithWeight}
          </Typography>
        )}
        {displayType !== DIAMOND_TYPES.CERTIFIED && getItemDetails(item, t) !== '—' && (
          <Typography variant="caption" color="text.secondary" display="block">
            {getItemDetails(item, t)}
          </Typography>
        )}
        <OrderItemClientNote item={item} sx={{ mt: 0.25 }} />
        <Box display="flex" justifyContent="space-between" mt={0.5}>
          <Typography variant="caption" color="text.secondary">
            {getItemPricePerCt(item)}/ct
          </Typography>
          <Typography variant="body2" fontWeight="bold">{displayPrice}</Typography>
        </Box>
      </CardContent>
    </Card>
  );
}

export default ClientOrderItemCard;
